import {Injectable} from "@angular/core";
import {ProductRemote} from "@app/core/product/domain/repositories/product.remote";
import {combineLatest, Observable} from "rxjs";
import {Product} from "@app/core/product/domain/dtos/product";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class GetSimilarProductsOfProductsUseCase {

    constructor(private productRemote:ProductRemote) {
    }

    execute(productCodes: string[], itemsPerPage:number, page:number): Observable<Product[]> {
        const firstThreeProductsCodes = productCodes.slice(0, 3);
        return combineLatest(firstThreeProductsCodes.map(productCode =>
            this.productRemote.getSimilarProducts(productCode, itemsPerPage, page))).pipe(
                map(   //Flatten the arrayOfList
                    (arrayOfLists: Product[][]) =>
                        arrayOfLists.reduce((previous, current) => previous.concat(current))
                )
        )
    }

}